/*
 * Append scripts or CSS to the page head.
 */
let filters = ['enabled', 'enabledIf', 'waitFor'];

function appendToHead(obj, type = 'script', filter = filters) {
    let attr = { script: 'src', link: 'href' }[type] || 'src';
    if (document.querySelector(`${type}[${attr}="${obj[attr]}"]`)) return obj.onload ? obj.onload() : true
    let elm = window.document.createElement(type);
    Object.entries(obj).filter(attr => !filter.includes(attr[0])).forEach((attr) => {
        (attr[1] instanceof Function) ? elm[attr[0]] = attr[1] : elm.setAttribute(attr[0], attr[1]);
    });
    try {
        return (document.querySelector('head') || window.document.body).appendChild(elm);
    } catch { return obj.onerror ? obj.onerror() : false }
}

/*
 * Return a promise that resolves/rejects on load or error of an element tag.
 */
function promiseAppendToHead(obj, type = 'script', filter = filters) {
    return new Promise((resolve, reject) => {
        appendToHead({
            ...obj,
            onload: () => resolve(obj),
            onerror: () => reject(obj),
        }, type, filter);
    });
}

/*
 *    import CDN from 'configs/cdn-settings';
 *    scriptByID('leaflet', CDN.javascripts.scripts);
 *    scriptByID('leaflet', CDN);
 */
function scriptByID(_id = null, arr = [], opts = {}) {
    if (!_id) return false;
    return (Array.isArray(arr) ? arr : arr?.javascripts?.scripts || []).some((script) => {
        let { id, ...rest } = script;
        if (new RegExp(`^${id}$`, 'i').test(_id)) {
            return appendToHead({ ...rest, ...opts });
        }
        return false;
    });
}

/*
 *    import CDN from 'configs/cdn-settings';
 *    styleByID('leaflet', CDN.stylesheets.sheets);
 *    styleByID('leaflet', CDN);
 */
function styleByID(_id = null, arr = [], opts = {}) {
    if (!_id) return false;
    return (Array.isArray(arr) ? arr : arr?.stylesheets?.sheets || []).some((sheet) => {
        let { id, ...rest } = sheet;
        if (new RegExp(`^${id}$`, 'i').test(_id)) {
            return appendToHead({ ...rest, ...opts }, 'link');
        }
        return false;
    });
}


export {
    appendToHead as default,
    promiseAppendToHead,
    scriptByID,
    styleByID,
}
